/**
 * Zendesk Marketplace Configuration
 * These values come from your Zendesk Partner Portal after Global OAuth approval
 */

export const ZENDESK_MARKETPLACE = {
  APP_ID: process.env.REACT_APP_ZENDESK_MARKETPLACE_APP_ID,
  NAME: process.env.REACT_APP_ZENDESK_MARKETPLACE_APP_NAME,
  ORG_ID: process.env.REACT_APP_ZENDESK_MARKETPLACE_ORG_ID
};

/**
 * Helper function to get required marketplace headers
 * Use this for all Zendesk API calls via ZAF client
 */
export const getMarketplaceHeaders = () => ({
  'X-Zendesk-Marketplace-App-Id': ZENDESK_MARKETPLACE.APP_ID,
  'X-Zendesk-Marketplace-Name': ZENDESK_MARKETPLACE.NAME,
  'X-Zendesk-Marketplace-Organization-Id': ZENDESK_MARKETPLACE.ORG_ID
});
